import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiParcelsDetailGet } from '@/entities/parcels/modules/api/parcels';

export const useParcelDetail = (id: string | undefined) =>
  useFetch({
    api: () => apiParcelsDetailGet(id ?? ''),
    keywords: queryKeys.parcels.detail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });
